<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <!--label="甲方公司"-->
            <a-form-item :label="$t('label.partyA')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                type="list"
                @change="handlePaDeptCodeChange"
                dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"
                v-decorator="[
                  'paCompanyCode',
                  { initialValue: initPaCompanyCode, rules: validatorRules.paCompanyCode.rules },
                ]"
                :trigger-change="true"
                :placeholder="$t('label.pleaseSelectPartyA')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="乙方养户"-->
            <a-form-item :label="$t('label.partyB')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                type="list"
                v-decorator="['pbFarmerCode', validatorRules.pbFarmerCode]"
                :trigger-change="true"
                :dict="dictPbFarmerCode"
                :placeholder="$t('label.pleaseSelectPartyB')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="合同编码"-->
            <a-form-item :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                :disabled="true"
                v-decorator="['code', validatorRules.code]"
                :placeholder="$t('label.pleaseEnterTheContractCode')"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="合同名称"-->
            <a-form-item :label="$t('label.contracName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入合同描述"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('name')" :popLists="getMainTablePop('name')">
                <a-input
                  v-decorator="['name', validatorRules.name]"
                  :read-only="whetherLang('name')"
                  @click="isLangClick('name', true)"
                  :placeholder="$t('label.pleaseEnterTheContractName')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--:label="$t('label.cooperationModel')"-->
            <a-form-item :label="$t('label.cooperationMode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['cooperMode', validatorRules.cooperMode]"
                :trigger-change="true"
                dictCode="arch_cooper_mode"
                :placeholder="$t('label.pleaseSelectTheCooperationMode')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="合同类型"-->
            <a-form-item :label="$t('label.contractType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['conType', validatorRules.conType]"
                :trigger-change="true"
                dictCode="contact_type"
                :placeholder="$t('label.pleaseSelectTheContractType')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="签订日期"-->
            <a-form-item :label="$t('label.dateOfSigning')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectTheDateOfSigning')"
                v-decorator="[
                  'partyBSignDate',
                  { initialValue: initPartyBSignDate, rules: validatorRules.partyBSignDate.rules },
                ]"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="生效日期"-->
            <a-form-item :label="$t('label.effectiveDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectEffectiveDate')"
                v-decorator="['conStartDate', validatorRules.conStartDate]"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="终止日期"-->
            <a-form-item :label="$t('label.terminationDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectTheTerminationDate')"
                v-decorator="['conEndDate', validatorRules.conEndDate]"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="饲养批次"-->
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                disabled
                v-decorator="['breedBatchCode', validatorRules.breedBatchCode]"

              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="签订地点"-->
            <a-form-item :label="$t('label.signingPlace')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['conAddress', validatorRules.conAddress]" placeholder="请输入签订地点"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('conAddress')" :popLists="getMainTablePop('conAddress')">
                <a-input
                  v-decorator="['conAddress', validatorRules.conAddress]"
                  :read-only="whetherLang('conAddress')"
                  @click="isLangClick('conAddress', true)"
                  :placeholder="$t('label.pleaseEnterThePlaceOfSigning')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="行业"-->
            <a-form-item :label="$t('label.industry')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['conIndustry']" placeholder="请输入行业"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('conIndustry')" :popLists="getMainTablePop('conIndustry')">
                <a-input
                  v-decorator="['conIndustry']"
                  :read-only="whetherLang('conIndustry')"
                  @click="isLangClick('conIndustry', false)"
                  :placeholder="$t('label.pleaseInputTheIndustry')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="部门"-->
            <a-form-item :label="$t('label.department')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['conIndustryDepart']" placeholder="请输入部门"></a-input> -->
              <mtc-lang-popover
                :whetherLang="whetherLang('conIndustryDepart')"
                :popLists="getMainTablePop('conIndustryDepart')"
              >
                <a-input
                  v-decorator="['conIndustryDepart']"
                  :read-only="whetherLang('conIndustryDepart')"
                  @click="isLangClick('conIndustryDepart', false)"
                  :placeholder="$t('label.pleaseEnterDepartmentName')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="合同文本"-->
            <a-form-item :label="$t('label.contractText')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['contractFileUrl']" placeholder="请输入合同文本"></a-input> -->
              <mtc-lang-popover
                :whetherLang="whetherLang('contractFileUrl')"
                :popLists="getMainTablePop('contractFileUrl')"
              >
                <a-input
                  v-decorator="['contractFileUrl']"
                  :read-only="whetherLang('contractFileUrl')"
                  @click="isLangClick('contractFileUrl', false)"
                  :placeholder="$t('label.pleaseEnterTheContractText')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="是否标准文本"-->
            <a-form-item :label="$t('label.whetherStandardText')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['isConStandard', { initialValue: 'Y' }, validatorRules.isConStandard]"
                :trigger-change="true"
                dictCode="is_standard_text"
                :placeholder="$t('label.pleaseSelectWhetherTheStandardContractText')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="币种"-->
            <a-form-item :label="$t('label.currency')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['conCurrency']" placeholder="请输入币种"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('conCurrency')" :popLists="getMainTablePop('conCurrency')">
                <a-input
                  v-decorator="['conCurrency']"
                  :read-only="whetherLang('conCurrency')"
                  @click="isLangClick('conCurrency', false)"
                  :placeholder="$t('label.pleaseEnterTheCurrency')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="本位币"-->
            <a-form-item :label="$t('label.localCurrency')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['conFunctionalCurrency']" placeholder="请输入本位币"></a-input> -->
              <mtc-lang-popover
                :whetherLang="whetherLang('conFunctionalCurrency')"
                :popLists="getMainTablePop('conFunctionalCurrency')"
              >
                <a-input
                  v-decorator="['conFunctionalCurrency']"
                  :read-only="whetherLang('conFunctionalCurrency')"
                  @click="isLangClick('conFunctionalCurrency', false)"
                  :placeholder="$t('label.pleaseEnterTheLocalCurrency')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="折本汇率"-->
            <a-form-item :label="$t('label.conversionRate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                v-decorator="['conDiscountRate', validatorRules.conDiscountRate]"
                :placeholder="$t('label.pleaseEnterTheConversionRate')"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <!--          <a-col :span="6" >-->
          <!--            <a-form-item label="养殖品类" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <j-dict-select-tag type="list" v-decorator="['breedClassCode' , validatorRules.breedClassCode]" :trigger-change="true" @change="handleBreedClass"-->
          <!--                                 dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :span="6" >-->
          <!--            <a-form-item label="养殖品系" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <j-dict-select-tag type="list" v-decorator="['breedVarietyCode', validatorRules.breedVarietyCode]" :trigger-change="true"-->
          <!--                                 :dictCode="dictBreedVarietyCode"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="8">
            <!--label="养殖品类"-->
            <a-form-item :label="$t('label.breedingCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['breedClassCode', validatorRules.breedClassCode]"
                :trigger-change="true"
                @change="handleBreedClass"
                dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')"
                :placeholder="$t('label.pleaseSelectSpecies')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="养殖品系"-->
            <a-form-item :label="$t('label.breedingStrain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['breedVarietyCode', validatorRules.breedVarietyCode]"
                :trigger-change="true"
                :dictCode="dictBreedVarietyCode"
                :placeholder="$t('label.pleaseSelectAStrain')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="代次"-->
            <a-form-item :label="$t('label.generation')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['batchType', validatorRules.batchType]"
                :trigger-change="true"
                dictCode="batch_type"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="养殖性别"-->
            <a-form-item :label="$t('label.gender')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['buffer1', { initialValue: 'F', rules: validatorRules.buffer1.rules }]"
                :trigger-change="true"
                dictCode="sex_animal"
                :placeholder="$t('label.pleaseSelectSpecies')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="养殖标准"-->
            <a-form-item :label="$t('label.breedingStandard')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedingStandards',validatorRules.breedingStandards]" :trigger-change="true" dictCode="breeding_standards" :placeholder="$t('label.pleaseSelectTheBreedingStandard')"/>
            </a-form-item>
          </a-col>
          <!--<a-col :span="8">
            <a-form-item label="养殖标准" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['breedingStandards', validatorRules.breedingStandards]"
                :trigger-change="true"
                dictCode="breeding_standards"
                placeholder="请选择养殖标准"
              />
            </a-form-item>
          </a-col>-->
          <a-col :span="8">
            <!--label="养户管理员"-->
            <a-form-item :label="$t('label.breederAdministrator')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['pbFarmerName', validatorRules.pbFarmerName]"
                :trigger-change="true"
                :dictCode="dictPbFarmerName"
                :placeholder="$t('label.pleaseEnterTheBreederAdministrator')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="服务组"-->
            <a-form-item :label="$t('label.serviceGroup')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                type="list"
                v-decorator="['paDeptCode', validatorRules.paDeptCode]"
                :trigger-change="true"
                :dict="dictPaDeptCode"
                :placeholder="$t('label.pleaseSelectTheServiceGroup')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="录入人"-->
            <a-form-item :label="$t('label.enteringPerson')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                type="list"
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="[
                  'conReporter',
                  { initialValue: initConReporter, rules: validatorRules.conReporter.rules },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="服务组长"-->
            <a-form-item :label="$t('label.serviceTeamLeader')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['serviceLeader', validatorRules.serviceLeader]"
                :trigger-change="true"
                :dictCode="dictServiceLeader"
                :placeholder="$t('label.pleaseEnterTheServiceGroupLeader')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="营销组长"-->
            <a-form-item :label="$t('label.marketingTeamLeader')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['mktLeader']"
                :trigger-change="true"
                :dictCode="dictMktLeader"
                :placeholder="$t('label.pleaseEnterTheMarketingTeamLeader')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="营销员"-->
            <a-form-item :label="$t('label.salesperson')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['mktMember']"
                :trigger-change="true"
                :dictCode="dictMktMember"
                :placeholder="$t('label.pleaseEnterTheMarketingStaff')"
              /> </a-form-item
            >.
          </a-col>
          <a-col :span="8">
            <!--label="变更合同编码"-->
            <a-form-item v-has="'parentConCode'" :label="$t('label.changeOfContractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['parentConCode']" :placeholder="$t('label.pleaseEnterTheChangeContractCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="变更时间"-->
            <a-form-item v-has="'postDate'" :label="$t('label.changeTime')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectTheTimeOfChange')"
                v-decorator="['postDate']"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="变更原因"-->
            <a-form-item v-has="'postReason'" :label="$t('label.reasonForChange')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['postReason']" placeholder="请输入变更原因"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('postReason')" :popLists="getMainTablePop('postReason')">
                <a-input
                  v-decorator="['postReason']"
                  :read-only="whetherLang('postReason')"
                  @click="isLangClick('postReason', false)"
                  :placeholder="$t('label.pleaseEnterTheReasonForChange')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="修改合同文本"-->
            <a-form-item v-has="'postReason'" :label="$t('label.modifyTheContractText')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['reContractFileUrl']" placeholder="请输入修改合同文本"></a-input> -->
              <mtc-lang-popover
                :whetherLang="whetherLang('reContractFileUrl')"
                :popLists="getMainTablePop('reContractFileUrl')"
              >
                <a-input
                  v-decorator="['reContractFileUrl']"
                  :read-only="whetherLang('reContractFileUrl')"
                  @click="isLangClick('reContractFileUrl', false)"
                  :placeholder="$t('label.pleaseEnterTheTextOfTheModifiedContract')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <!--          <a-col :span="6" >-->
          <!--            <a-form-item label="是否结算" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--              <j-dict-select-tag type="list" v-decorator="['status']" :trigger-change="true" dictCode="" placeholder="请选择是否结算"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.breedingStandard')" :key="refKeys[0]" :forceRender="true">
        <contract-breed-standard-form
          :tableName="subTable[0]"
          ref="contractBreedStandardForm"
          @validateError="validateError"
          :disabled="formDisabled"
        ></contract-breed-standard-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.securityDeposit')" :key="refKeys[1]" :forceRender="true">
        <efs-std-margin-form
          ref="efsStdMarginForm"
          :tableName="subTable[1]"
          @validateError="validateError"
          :disabled="formDisabled"
        ></efs-std-margin-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.materialSettlementPrice')" :key="refKeys[2]" :forceRender="true">
        <settle-price-list-form
          ref="settlePriceListForm"
          :tableName="subTable[2]"
          @validateError="validateError"
          :disabled="formDisabled"
        ></settle-price-list-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.fees')" :key="refKeys[3]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[3]"
          :tableName="subTable[3]"
          :loading="viewEfsStlFeeTable.loading"
          :columns="viewEfsStlFeeTable.columns"
          :dataSource="viewEfsStlFeeTable.dataSource"
          :maxHeight="300"
          :disabled="true"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"
        />
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.subsidy')" :key="refKeys[4]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[4]"
          :tableName="subTable[4]"
          :loading="viewEfsStlSubsidyTable.loading"
          :columns="viewEfsStlSubsidyTable.columns"
          :dataSource="viewEfsStlSubsidyTable.dataSource"
          :maxHeight="300"
          :disabled="true"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"
        />
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.recoveryPrice')" :key="refKeys[5]" :forceRender="true">
        <recycle-fee-form
          ref="recycleFeeForm"
          :tableName="subTable[5]"
          @validateError="validateError"
          :disabled="formDisabled"
        ></recycle-fee-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.recoverySettlement')" :key="refKeys[6]" :forceRender="true">
        <settlement-all-form
          ref="settlementAllForm"
          :tableName="subTable[6]"
          @validateError="validateError"
          :disabled="formDisabled"
        ></settlement-all-form>
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.remarks')" :key="refKeys[7]" :forceRender="true">
        <efs-md-contract-detail-form
          ref="efsMdContractDetailForm"
          :mainTable="subTable[7]"
          @validateError="validateError"
          :disabled="formDisabled"
        ></efs-md-contract-detail-form>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import ContractBreedStandardForm from './ContractBreedStandardForm.vue'
import SettlePriceListForm from './SettlePriceListForm.vue'
import RecycleFeeForm from './RecycleFeeForm.vue'
import SettlementAllForm from './SettlementAllForm.vue'
import EfsMdContractDetailForm from './EfsMdContractDetailForm.vue'
import EfsStdMarginForm from './EfsStdMarginForm.vue'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import moment from 'moment'
import { getCurrentUser } from '@/api/api'

export default {
  name: 'EfsMdContractForm',
  mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
    ContractBreedStandardForm,
    EfsStdMarginForm,
    SettlePriceListForm,
    RecycleFeeForm,
    SettlementAllForm,
    EfsMdContractDetailForm,
    JDate,
    JDictSelectTag,
  },
  data() {
    return {
      mainTable: 'efs_md_contract',
      subTable: [
        'efs_md_contract_detail',
        'efs_std_margin',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
        'efs_md_contract_detail',
      ],
      isCodeDisabled: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        paCompanyCode: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectPartyA') }],
        },
        pbFarmerCode: {
          rules: [
            { required: true, message: this.$t('label.pleaseSelectPartyB')},
          ]
        },
        name: {
          rules: [{ required: true, message: this.$t('label.pleaseEnterTheContractName') }],
        },
        cooperMode: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheCooperationMode')}],
        },
        conType: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheContractType') }],
        },
        partyBSignDate: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheDateOfSigning') }],
        },
        conStartDate: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheDateOfSigning') }],
        },
        conEndDate: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheTerminationDate') }],
        },
        conAddress: {
          rules: [{ required: true, message: this.$t('label.pleaseEnterThePlaceOfSigning') }],
        },
        isConStandard: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectWhetherTheStandardContractText') }],
        },
        conDiscountRate: {
          rules: [{ required: false }, { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') }],
        },
        breedClassCode: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectSpecies') }],
        },
        breedVarietyCode: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectAStrain') }],
        },
        buffer1: {
          rules: [{ required: true, message: this.$t('label.gender') }],
        },
        pbFarmerName: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterTheBreederAdministrator')},
          ]
        },
        paDeptCode: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheServiceGroup') }],
        },
        conReporter: {
          rules: [{ required: true, message: this.$t('label.enteringPerson') }],
        },
        serviceLeader: {
          rules: [
            { required: true, message: this.$t('label.pleaseEnterTheServiceGroupLeader')},
          ]
        },
        batchType: {
          rules: [{ required: true, message: this.$t('label.batchType') }],
        },
        breedingStandards: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectTheBreedingStandard') }],
        },
        // mktLeader: {
        //   rules: [
        //     { required: true, message: '请选择营销组长!'},
        //   ]
        // },
        // mktMember: {
        //   rules: [
        //     { required: true, message: '请选择营销员!'},
        //   ]
        // },
      },
      refKeys: [
        'contractBreedStandard',
        'efsStdMargin',
        'settlePriceList',
        'viewEfsStlSubsidy',
        'viewEfsStlFee',
        'recycleFee',
        'settlementAll',
        'efsMdContractDetail',
      ],
      tableKeys: ['viewEfsStlSubsidy', 'viewEfsStlFee'],
      activeKey: 'efsMdContractDetail',
      // 合同明细
      contractBreedStandardTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [],
      },
      // 保证金
      efsStdMarginTable: {
        loading: false,
        tableName: 'efs_std_margin',
        dataSource: [],
        columns: [],
      },
      settlePriceListTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [],
      },
      recycleFeeTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [],
      },
      settlementAllTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [],
      },
      efsMdContractDetailTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [],
      },
      // view_efs_stl_subsidy 补贴
      viewEfsStlSubsidyTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [
          {
            //title: '业务类型',
            title: this.$t('tableHeader.businessType'),
            key: 'itemText',
            type: FormTypes.input,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '业务项目',
            title: this.$t('tableHeader.businessItem'),
            key: 'archName',
            type: FormTypes.input,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '费用金额',
            title: this.$t('tableHeader.expenseAmount'),
            key: 'unitPrice',
            type: FormTypes.inputNumber,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '审核状态',
            title: this.$t('tableHeader.auditStatus'),
            key: 'approvalStatus',
            type: FormTypes.select,
            dicCode: 'shzt',
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
        ],
      },
      // view_efs_stl_fee费用
      viewEfsStlFeeTable: {
        loading: false,
        tableName: 'efs_md_contract_detail',
        dataSource: [],
        columns: [
          {
            //title: '业务类型',
            title: this.$t('tableHeader.businessType'),
            key: 'itemText',
            type: FormTypes.input,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '业务项目',
            title: this.$t('tableHeader.businessItem'),
            key: 'archName',
            type: FormTypes.input,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '单价',
            title: this.$t('tableHeader.unitPrice'),
            key: 'unitPrice',
            type: FormTypes.inputNumber,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
          {
            //title: '审核状态',
            title: this.$t('tableHeader.auditStatus'),
            key: 'approvalStatus',
            type: FormTypes.select,
            dicCode: 'shzt',
            width: '200px',
            placeholder: this.$t('tip.pleaseInput')+'${title}',
            defaultValue: '',
          },
        ],
      },
      url: {
        add: '/newContractManage/efsMdContract/add',
        edit: '/newContractManage/efsMdContract/edit',
        queryById: '/newContractManage/efsMdContract/queryById',
        efsMdContractDetail: {
          list: '/newContractManage/efsMdContract/queryEfsMdContractDetailByMainId',
        },
        efsStdMargin: {
          list: '/newContractManage/efsMdContract/queryEfsStdMarginByMainId',
        },
        viewEfsStlSubsidy: {
          list: '/newContractManage/efsMdContract/queryViewEfsStlSubsidyByMainId',
        },
        viewEfsStlFee: {
          list: '/newContractManage/efsMdContract/queryViewEfsStlFeeByMainId',
        },
      },
      initPaCompanyCode: null,
      initConReporter: null,
      dictPaDeptCode: '1',
      dictPbFarmerCode: '2',
      dictPbFarmerName: '3',
      dictServiceLeader: '4',
      dictMktLeader: '5',
      dictMktMember: '6',
      dictBreedVarietyCode: '',
      initPartyBSignDate: moment(new Date()).format('YYYY-MM-DD'),
    }
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：false流程表单 true普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
    getCurrentUser().then((res) => {
      if (res.success) {
        this.initConReporter = res.result.username
        this.initPaCompanyCode = res.result.orgCode
        this.dictPaDeptCode =
          "sys_depart,depart_name,org_code,org_code like '" +
          res.result.orgCode +
          "*' and org_category='2' and del_flag='0' order by depart_order asc"
        this.dictPbFarmerCode =
          "efs_md_farmer,CONCAT(code((comma))((verticalLine))((comma))name),code,company_code like '" +
          res.result.orgCode +
          "*' and del_flag='N'"
          //养户管理员
        this.dictPbFarmerName =
          "view_efs_user_depart,DISTINCT realname,username,org_code like '" +
          res.result.orgCode +
          "*' and post = '2' and org_category='2' and del_flag='0'"
          //服务组长
        this.dictServiceLeader =
          "view_efs_user_depart,DISTINCT realname,username,org_code like '" +
          res.result.orgCode +
          "*' and post = '5' and org_category='2' and del_flag='0'"
          //营销组长
        this.dictMktLeader =
          "view_efs_user_depart,DISTINCT realname,username,org_code like '" +
          res.result.orgCode +
          "*' and post = '6' and org_category='2' and del_flag='0'"
          // 营销员
        this.dictMktMember =
          "view_efs_user_depart,DISTINCT realname,username,org_code like '" +
          res.result.orgCode +
          "*' and post = '4' and org_category='2' and del_flag='0'"
      }
    })
  },
  methods: {
    addBefore() {
      this.form.resetFields()
      this.$refs.contractBreedStandardForm.clearFormData()
      this.$refs.efsStdMarginForm.clearFormData()
      this.$refs.settlePriceListForm.clearFormData()
      this.$refs.recycleFeeForm.clearFormData()
      this.$refs.settlementAllForm.clearFormData()
      this.$refs.efsMdContractDetailForm.clearFormData()
    },
    // getAllTable() {
    //   return new Promise(resolve => {
    //     resolve([]);
    //   })
    // },
    getAllTable() {
      let values = this.tableKeys.map((key) => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter(record) {
      let fieldval = pick(
        this.model,
        'paCompanyCode',
        'pbFarmerCode',
        'code',
        'name',
        'cooperMode',
        'conType',
        'breedBatchCode',
        'partyBSignDate',
        'conStartDate',
        'conEndDate',
        'conAddress',
        'isConStandard',
        'conIndustry',
        'conIndustryDepart',
        'contractFileUrl',
        'reContractFileUrl',
        'conReporter',
        'serviceLeader',
        'mktLeader',
        'mktMember',
        'conCurrency',
        'conFunctionalCurrency',
        'conDiscountRate',
        'conVersion',
        'parentConCode',
        'postDate',
        'postReason',
        'breedClassCode',
        'buffer1',
        'breedVarietyCode',
        'pbFarmerName',
        'paDeptCode',
        'approvalStatus',
        'batchType',
        'breedingStandards'
      )
      this.model = Object.assign({}, record)
      // 加载子表数据
      if (this.model.id) {
        let params = { code: this.model.code }
        if (this.model.validFlag == 'N') {
          this.isCodeDisabled = false
        } else if (this.model.validFlag == 'Y') {
          this.isCodeDisabled = true
        }
        this.handlePaDeptCodeChange(this.model.paCompanyCode)
        this.handleBreedClass(this.model.breedClassCode)
        this.requestSubTableData(this.url.viewEfsStlSubsidy.list, params, this.viewEfsStlSubsidyTable)
        this.requestSubTableData(this.url.viewEfsStlFee.list, params, this.viewEfsStlFeeTable)
      } else {
        this.isCodeDisabled = false
        this.model.paDeptCode = ''
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
        this.$refs.contractBreedStandardForm.initFormData(this.url.efsMdContractDetail.list, this.model.id)
        this.$refs.efsStdMarginForm.initFormData(this.url.efsStdMargin.list, this.model.id)
        this.$refs.settlePriceListForm.initFormData(this.url.efsMdContractDetail.list, this.model.id)
        this.$refs.recycleFeeForm.initFormData(this.url.efsMdContractDetail.list, this.model.id)
        this.$refs.settlementAllForm.initFormData(this.url.efsMdContractDetail.list, this.model.id)
        this.$refs.efsMdContractDetailForm.initFormData(this.url.efsMdContractDetail.list, this.model.id)
      })
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        contractBreedStandardList: this.$refs.contractBreedStandardForm.getFormData(),
        efsStdMarginList: this.$refs.efsStdMarginForm.getFormData(),
        settlePriceList: this.$refs.settlePriceListForm.getFormData(),
        recycleFeeList: this.$refs.recycleFeeForm.getFormData(),
        settlementAllList: this.$refs.settlementAllForm.getFormData(),
        efsMdContractDetailList: this.$refs.efsMdContractDetailForm.getFormData(),
      }
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'paCompanyCode',
          'pbFarmerCode',
          'code',
          'name',
          'cooperMode',
          'conType',
          'breedBatchCode',
          'partyBSignDate',
          'conStartDate',
          'conEndDate',
          'conAddress',
          'isConStandard',
          'conIndustry',
          'conIndustryDepart',
          'contractFileUrl',
          'reContractFileUrl',
          'conReporter',
          'serviceLeader',
          'mktLeader',
          'mktMember',
          'conCurrency',
          'conFunctionalCurrency',
          'conDiscountRate',
          'conVersion',
          'parentConCode',
          'postDate',
          'postReason',
          'breedClassCode',
          'buffer1',
          'breedVarietyCode',
          'pbFarmerName',
          'paDeptCode',
          'approvalStatus',
          'batchType',
          'breedingStandards'
        )
      )
    },
    /** 确定按钮点击事件 */
    handleOk() {
      if (this.$refs.contractBreedStandardForm.getFormData().length == 0) {
        return
      }
      if (this.$refs.efsStdMarginForm.getFormData().length == 0) {
        return
      }
      if (this.$refs.settlePriceListForm.getFormData().length == 0) {
        return
      }
      if (this.$refs.efsMdContractDetailForm.getFormData().length == 0) {
        return
      }
      if (this.$refs.recycleFeeForm.getFormData().length == 0) {
        return
      }
      /** 触发表单验证 */
      this.getAllTable()
        .then((tables) => {
          /** 一次性验证主表和所有的次表 */
          return validateFormAndTables(this.form, tables)
        })
        .then((allValues) => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          // 处理主表多语言数据-开始
          this.sysLanguageList = []
          for (const key in this.mainTableLangLists) {
            // 将数组对象展开
            for (let i = 0; i < this.mainTableLangLists[key].length; i++) {
              this.sysLanguageList.push(this.mainTableLangLists[key][i])
            }
          }

          // 处理主表多语言数据-结束
          let formData = this.classifyIntoFormData(allValues)
          this.$set(formData, 'sysLanguageList', this.sysLanguageList)

          // 发起请求
          return this.request(formData)
        })
        .catch((e) => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
          } else {
            console.error(e)
          }
        })
    },

    handlePaDeptCodeChange(value) {
      this.dictPaDeptCode =
        "sys_depart,depart_name,org_code,org_code like '" +
        value +
        "*' and org_category='2' and del_flag='0' order by depart_order asc"
      this.model.paDeptCode = ''
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'paDeptCode'))
      })
    },
    handleBreedClass(value) {
      this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')"
      this.model.breedVarietyCode = ''
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'breedVarietyCode'))
      })
    },
  },
}
</script>

<style scoped>
</style>